import { Component } from "react";
import PlayerOverrides from "../data/PlayerOverrides.js";

class ProfileUtils extends Component {
  static fecthProfileData = async (server, profileId, leaderboardId) => {
    var profile = {
      profileId: profileId,
      name: undefined,
      country: undefined,
      games: undefined,
      streak: undefined,
      wins: undefined,
      looses: undefined,
      winPercentage: undefined,
      eloRM1vs1: undefined,
      eloEW1vs1: undefined,
      highestRatingRM1vs1: undefined,
      highestRatingEW1vs1: undefined,
    };
    try {
      const profileUrl = `${server}/api/leaderboard?game=aoe2de&leaderboard_id=${leaderboardId}&start=1&count=1&profile_id=${profileId}`;
      const response = await fetch(`${profileUrl}`);
      const data = await response.json();
      //console.log(`data (${profileId}): ${JSON.stringify(data)}`); // DEBUG
      if (data && data.leaderboard.length > 0) {
        profile = {
          profileId: profileId,
          name: data.leaderboard[0].name,
          country: data.leaderboard[0].country,
          games: data.leaderboard[0].games,
          streak: data.leaderboard[0].streak,
          wins: data.leaderboard[0].wins,
          looses: data.leaderboard[0].games - data.leaderboard[0].wins,
          eloRM1vs1:
            leaderboardId === 3 ? data.leaderboard[0].rating : undefined,
          highestRatingRM1vs1:
            leaderboardId === 3
              ? data.leaderboard[0].highest_rating
              : undefined,
          eloEW1vs1:
            leaderboardId === 13 ? data.leaderboard[0].rating : undefined,
          highestRatingEW1vs1:
            leaderboardId === 13
              ? data.leaderboard[0].highest_rating
              : undefined,
          winPercentage:
            Math.trunc(
              (data.leaderboard[0].wins / data.leaderboard[0].games) * 100 * 100
            ) / 100,
        };
      }
    } catch (error) {
      console.log(error);
    }
    return profile;
  };

  static mergeProfileData = (profile1, profile2) => {
    var profile = {};

    for (var k in profile1) {
      profile[k] = profile1[k] ? profile1[k] : profile2[k];
    }
    return profile;
  };

  static customizePlayersData = (profile) => {
    var customizedProfile = profile;
    var profileOverrides = PlayerOverrides[profile.profileId];

    for (var k in profileOverrides) {
      if (k !== "elo" && k !== "highestRating") {
        customizedProfile[k] = profileOverrides[k];
      }
    }

    return customizedProfile;
  };
}

export default ProfileUtils;
